import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { DoubleListBox, DoubleListBoxContextProvider } from '@bingads-webui-react/double-list-box-fluent';
import { CampaignData } from './campaign-data';

export const CampaignSelectionDoubleListBox = ({ coupon, onSelectionChange }) => {
  const dlbRef = useRef();

  return (
    <DoubleListBoxContextProvider
      pageSize={10}
      pageNumber={1}
    >
      <CampaignData coupon={coupon} />
      <DoubleListBox
        componentRef={dlbRef}
        onSelectionChange={onSelectionChange}
      />
    </DoubleListBoxContextProvider>
  );
};

CampaignSelectionDoubleListBox.propTypes = {
  coupon: PropTypes.shape({}).isRequired,
  onSelectionChange: PropTypes.func.isRequired,
};
